"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateDimension = exports.notifyInvalidMinSize = exports.confirmResize = void 0;
var _messageBox = _interopRequireDefault(require("element-ui/packages/message-box"));
var _utils = require("@thinkvn/utils");
var _dimension = require("./dimension");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const confirmResize = async (originSize, resizedSize) => {
  try {
    await _messageBox.default.confirm(`<div>
           <div>B\u1EA1n \u0111ang upload \u1EA3nh c\xF3 k\xEDch th\u01B0\u1EDBc ${originSize.width}x${originSize.height}</div>
           <div>Ch\xFAng t\xF4i s\u1EBD t\u1EF1 \u0111\u1ED9ng resize sang k\xEDch th\u01B0\u1EDBc ${resizedSize.width}x${resizedSize.height}</div>
      </div>`, "C\u1EA3nh b\xE1o", {
      confirmButtonText: "Resize ngay",
      cancelButtonText: "Upload \u1EA3nh kh\xE1c",
      type: "warning",
      dangerouslyUseHTMLString: true
    });
    return true;
  } catch {
    return false;
  }
};
exports.confirmResize = confirmResize;
const notifyInvalidMinSize = async (originSize, minSize) => {
  try {
    await _messageBox.default.confirm(`<div>
           <div>B\u1EA1n \u0111ang upload \u1EA3nh c\xF3 k\xEDch th\u01B0\u1EDBc ${originSize.width}x${originSize.height}</div>
           <div>B\u1EA1n c\u1EA7n upload \u1EA3nh c\xF3 k\xEDch th\u01B0\u1EDBc th\u1EA5p nh\u1EA5t l\xE0: ${minSize.width}x${minSize.height}</div>
      </div>`, "C\u1EA3nh b\xE1o", {
      showConfirmButton: false,
      cancelButtonText: "Upload \u1EA3nh kh\xE1c",
      type: "warning",
      dangerouslyUseHTMLString: true
    });
    return true;
  } catch {
    return false;
  }
};
exports.notifyInvalidMinSize = notifyInvalidMinSize;
const validateDimension = async (file, {
  allowFileDimensionValidation,
  allowResizeFile,
  minSize,
  targetSize,
  resizedSize,
  callbackResize
}) => {
  if (!allowFileDimensionValidation || !minSize) return true;
  const originSize = await (0, _dimension.getDimensionFile)(file);
  const isValidMinSize = originSize.width >= minSize.width;
  const isValidSize = (0, _utils.isEqual)(originSize, targetSize) || (0, _utils.isEqual)(originSize, resizedSize);
  if (!isValidMinSize) {
    await notifyInvalidMinSize(originSize, minSize);
    throw "INVALID_DIMENSION_MIN_SIZE";
  }
  if (!isValidSize) {
    if (allowResizeFile) {
      const isConfirm = await confirmResize(originSize, resizedSize);
      if (!isConfirm || !callbackResize) {
        throw "INVALID_DIMENSION_SIZE";
      } else {
        await callbackResize();
      }
    } else {
      await notifyInvalidMinSize(originSize, targetSize);
      throw "INVALID_DIMENSION_MIN_SIZE";
    }
  }
  return true;
};
exports.validateDimension = validateDimension;